import React, { memo } from "react"

const Tooltip = memo(({ text, children }) => {
  return (
    <div className="group relative h-full w-full">
      <span className="pointer-events-none absolute -top-16 left-1/2 -translate-x-1/2 shadow-md border rounded-[4px] border-[#3399FF] bg-[#3399FF] whitespace-nowrap text-white px-[24px] py-[10px] opacity-0 transition before:absolute before:left-1/2 before:top-full before:-translate-x-1/2 before:border-8 before:border-transparent before:border-t-[#3399FF] before:content-[''] group-hover:opacity-100">
        {text}
      </span>

      {children}
    </div>
  )
})

export default Tooltip
